import { render, staticRenderFns } from "./TastingGroupCreate.vue?vue&type=template&id=0223684b&scoped=true&"
import script from "./TastingGroupCreate.vue?vue&type=script&lang=js&"
export * from "./TastingGroupCreate.vue?vue&type=script&lang=js&"
import style0 from "./TastingGroupCreate.vue?vue&type=style&index=0&id=0223684b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223684b",
  null
  
)

export default component.exports